var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Author',
        to: '/author'
      }, {
        label: 'Add New'
      }],
      "title": "New Author"
    }
  }), _c('div', {
    staticClass: "bg-white p-4"
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "flex-col w-1/2 px-0 py-0"
  }, [_c('label', {
    staticClass: "block font-medium mb-3 text-gray-700"
  }, [_vm._v("Author Image (Optional)")]), _c('div', {
    staticClass: "relative w-36 h-36 border-2 border-dashed bg-gray-100 border-gray-300 rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-50",
    on: {
      "click": _vm.triggerFileUpload
    }
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), this.imageFile ? _c('div', {
    staticClass: "absolute inset-0"
  }, [_c('img', {
    staticClass: "object-cover w-full h-full rounded-lg",
    attrs: {
      "src": this.imageFile,
      "alt": "Author Image"
    }
  }), _c('button', {
    staticClass: "absolute top-1 right-1 bg-white text-red-500 rounded-full py-0.5 px-1.5 hover:bg-gray-100",
    attrs: {
      "title": "Remove image"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.removeImage.apply(null, arguments);
      }
    }
  }, [_vm._v(" ✕ ")])]) : _c('div', {
    staticClass: "flex justify-center flex-col text-center align-middle items-center text-gray-400"
  }, [_c('svg', {
    staticClass: "w-6 h-6 text-gray-500 text-center dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "20",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v6.41A7.5 7.5 0 1 0 10.5 22H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Z",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9 16a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z",
      "clip-rule": "evenodd"
    }
  })]), _c('p', {
    staticClass: "text-sm text-gray-500 m-0"
  }, [_vm._v("Upload Image")]), _c('p', {
    staticClass: "text-xs text-gray-400 m-0"
  }, [_vm._v("Max 2MB")])])]), _vm.errorMessageFile ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v(_vm._s(_vm.errorMessageFile))]) : _vm._e(), _c('label', {
    staticClass: "block mt-3 mb-3 font-medium text-gray-700"
  }, [_vm._v("Author Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.name,
      expression: "form.name"
    }],
    class: ['w-full rounded-md px-4 py-2.5 mb-3 text-sm focus:outline-none focus:ring-2', _vm.submitted && !_vm.form.name ? 'bg-red-300 focus:ring-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter Author Name"
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value);
      }
    }
  }), _vm.submitted && !_vm.form.name ? _c('p', {
    staticClass: "text-red-500 text-sm mt-0"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('div', {
    staticClass: "grid grid-cols-2 gap-4"
  }, [_c('div', [_c('label', {
    staticClass: "block mt-0 mb-3 font-medium text-gray-700"
  }, [_vm._v("First Name (Optional)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.first_name,
      expression: "form.first_name"
    }],
    class: ['w-full rounded-md px-4 py-2.5 bg-gray-50 text-sm focus:outline-none focus:ring-2'],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter First Name"
    },
    domProps: {
      "value": _vm.form.first_name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "first_name", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block mt-0 mb-3 font-medium text-gray-700"
  }, [_vm._v("Last Name (Optional)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.last_name,
      expression: "form.last_name"
    }],
    class: ['w-full rounded-md px-4 py-2.5 bg-gray-50 text-sm focus:outline-none focus:ring-2'],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter Last Name"
    },
    domProps: {
      "value": _vm.form.last_name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "last_name", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block mt-0 mb-3 font-medium text-gray-700"
  }, [_vm._v("Academic Title (Optional)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.academic_title,
      expression: "form.academic_title"
    }],
    class: ['w-full rounded-md  px-4 py-2.5 bg-gray-50 text-sm focus:outline-none focus:ring-2'],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter Academic Title"
    },
    domProps: {
      "value": _vm.form.academic_title
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "academic_title", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block mt-0 font-medium text-gray-700"
  }, [_vm._v("Birth Date (Optional)")]), _c('DatetimeCustom', {
    staticClass: "mt-2 w-full mr-1.5",
    attrs: {
      "timeDate": false,
      "label": ''
    },
    model: {
      value: _vm.form.birthdate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "birthdate", $$v);
      },
      expression: "form.birthdate"
    }
  })], 1)]), _c('label', {
    staticClass: "block mt-3 mb-3 font-medium text-gray-700"
  }, [_vm._v("Description (Optional)")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.meta,
      expression: "form.meta"
    }],
    staticClass: "bg-gray-50 py-2.5 px-2 border h-36 rounded-lg w-full",
    attrs: {
      "id": "coupon-description",
      "placeholder": "Enter description about author...",
      "rows": "4"
    },
    domProps: {
      "value": _vm.form.meta
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "meta", $event.target.value);
      }
    }
  }), _c('label', {
    staticClass: "text-gray-600 text-sm font-semibold mb-3 mt-3 block"
  }, [_vm._v("Status")]), _c('div', [_c('button', {
    staticClass: "w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none",
    class: {
      'bg-blue-700': _vm.form.isActive,
      'bg-gray-300': !_vm.form.isActive
    },
    attrs: {
      "clas": "",
      "type": "button"
    },
    on: {
      "click": _vm.toggleActive
    }
  }, [_c('span', {
    staticClass: "w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200",
    class: {
      'translate-x-6': _vm.form.isActive,
      'translate-x-0': !_vm.form.isActive
    }
  })])])]), _c('div', {
    staticClass: "flex items-center space-x-4 mt-3"
  }, [_c('button', {
    staticClass: "bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-3 py-2 rounded-md",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Save ")]), _c('button', {
    staticClass: "border border-gray-300 text-gray-700 text-sm font-medium px-3 py-2 rounded-md hover:bg-gray-50",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/author');
      }
    }
  }, [_vm._v(" Cancel ")])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }